function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.641 9.634L13.202 9.634 13.202.072 3.641.072zM10.161 10.9L10.161 13.4 7.661 13.4M3.1 13.4L.6 13.4.6 10.9M.6 6.339L.6 3.839 3.1 3.839",
  transform: "translate(0 1) translate(0 .527)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M7.661 4.366L10.161 4.366 10.161 6.866",
  transform: "translate(0 1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M3.641 10.161L10.782 10.161 10.782 3.707 3.641 3.707z",
  transform: "translate(0 1)"
}));

var SvgMerge = function SvgMerge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merge.e274f81b.svg";
export { ForwardRef as ReactComponent };